<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_MS = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Nicht reaktiv: Timer und Anfragezähler je Komponenteninstanz.
    this.timer = null;
    this.requestId = 0;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.invalidate();
  },

  watch: {
    search(val) {
      if (!val) {
        this.invalidate();
        this.items = this.select ? [this.select] : [];
        return;
      }

      if (this.select && val === this.select.text) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage; verspätete Antworten werden verworfen.
    invalidate() {
      this.requestId++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.invalidate();

      const id = this.requestId;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoderReady.then(geocoder => {
          if (id !== this.requestId) {
            return null;
          }

          return geocoder.autocomplete(value).then(items => {
            if (id === this.requestId) {
              this.items = items;
            }
          });
        }).catch(() => {
          if (id === this.requestId) {
            this.items = [];
          }
        }).then(() => {
          if (id === this.requestId) {
            this.loading = false;
          }
        });
      }, DEBOUNCE_MS);
    },

    change(o) {
      this.invalidate();
      this.items = o ? [o] : [];
      this.$emit("change", o);
    }
  }
};
</script>
